import React, { useState } from "react";
import Aside from "../modules/SideNav/Aside";
import Help from "../components/Help/Help";

const HelpLayout = () => {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
       <Help handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
};

export default HelpLayout;
